"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonAnimation = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTransitionGroup = require("react-transition-group");

var _LoadingAnimation = _interopRequireDefault(require("../../foundation/LoadingAnimation"));

var _Icons = require("../../foundation/Icons");

var _Popover = _interopRequireDefault(require("../../modules/Popover"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ButtonAnimation = function ButtonAnimation(props) {
  var children = props.children,
      onClick = props.onClick,
      classNames = props.classNames,
      isDisabled = props.isDisabled,
      isError = props.isError,
      errorMessage = props.errorMessage,
      errorMessageHeading = props.errorMessageHeading,
      errorMessagePlacement = props.errorMessagePlacement,
      isSuccess = props.isSuccess,
      isLoading = props.isLoading,
      isLight = props.isLight;

  var onButtonClick = function onButtonClick(event) {
    if (!props.isDisabled) {
      if (onClick) {
        onClick(event);
      }
    }
  };

  var buttonClassName = (0, _classnames.default)({
    'button-animation': true,
    'button-animation--disabled': isDisabled,
    'button-animation--error': isError,
    'button-animation--loading': isLoading,
    'button-animation--success': isSuccess,
    'button-animation--light': isLight
  }, classNames);
  var shouldShowChildren = !isLoading && !isSuccess;
  var shouldShowLoader = isLoading && !isSuccess;
  var shouldShowError = !isLoading && isError;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "button-anmimation-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
    isError: true,
    isVisible: shouldShowError,
    menuPlacement: errorMessagePlacement,
    referenceElement: /*#__PURE__*/_react.default.createElement("button", {
      className: buttonClassName,
      onClick: onButtonClick,
      disabled: isDisabled
    }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      in: shouldShowChildren,
      unmountOnExit: true,
      timeout: 100,
      classNames: "children-transition"
    }, /*#__PURE__*/_react.default.createElement("span", null, children)), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      in: shouldShowLoader,
      unmountOnExit: true,
      timeout: 200,
      classNames: "loader-transition"
    }, /*#__PURE__*/_react.default.createElement(_LoadingAnimation.default, {
      classNames: "button-animation__spinner",
      strokeWidth: "16%",
      strokeColor: "white"
    })), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      in: isSuccess,
      unmountOnExit: true,
      timeout: 200,
      classNames: "success-transition"
    }, /*#__PURE__*/_react.default.createElement(_Icons.IcoCheck, {
      className: "button-animation__check-ico"
    })))
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", {
    className: "button-animation__error-h2"
  }, errorMessageHeading), errorMessage)));
};

exports.ButtonAnimation = ButtonAnimation;
ButtonAnimation.propTypes = {
  isDisabled: _propTypes.default.bool.isRequired,
  isLoading: _propTypes.default.bool.isRequired,
  isSuccess: _propTypes.default.bool.isRequired,
  isError: _propTypes.default.bool.isRequired,
  errorMessagePlacement: _propTypes.default.oneOf(['top', 'bottom']).isRequired,
  onClick: _propTypes.default.func,
  classNames: _propTypes.default.any,
  isLight: _propTypes.default.bool,
  errorMessageHeading: _propTypes.default.string,
  errorMessage: _propTypes.default.string.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.string]).isRequired
};
var defaultProps = {
  isDisabled: false,
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessagePlacement: 'bottom'
};
ButtonAnimation.defaultProps = defaultProps;
var _default = ButtonAnimation;
exports.default = _default;